import {
  create as createApi,
  sampleExcelDownload as sampleExcelDownloadApi,
  search as searchApi,
  stop as stopApi,
  update as updateApi,
  uploadFile as uploadFileApi
} from "../../service/StaffService";

export const CREATE_SUCCESS = "STAFF_CREATE_SUCCESS";
export const CREATE_FAIL = "STAFF_CREATE_FAIL";
export const UPLOAD_FILE_SUCCESS = "STAFF_UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "STAFF_UPLOAD_FILE_SUCCESS";
export const SEARCH = "STAFF_SEARCH";
export const UPDATE_SUCCESS = "STAFF_UPDATE_SUCCESS";
export const UPDATE_FAIL = "STAFF_UPDATE_FAIL";
export const ACCOUNT_STOP = "STAFF_ACCOUNT_STOP";
export const EXCEL_DOWNLOAD = "STAFF_EXCEL_DOWNLOAD";

export const create = request => dispatch => {
  createApi(request)
    .then(data => {
      if (data.code) {
        dispatch({
          type: CREATE_FAIL,
          payload: `メッセージコード: ${data.messageCode}\r\nメッセージ：${data.message}`
        });
        alert(`メッセージコード: ${data.messageCode}\r\nメッセージ：${data.message}`);
      } else if (data.message) {
        dispatch({
          type: CREATE_FAIL,
          payload: data.message
        });
        alert(data.message);
      } else {
        dispatch({ type: CREATE_SUCCESS, payload: { staff: request, message: "教職員情報の登録が完了しました。" } });
        alert("教職員情報の登録が完了しました。");
      }
    })
    .catch(error => {
      dispatch({
        type: CREATE_FAIL,
        payload: "教職員情報の登録中にエラーが発生しました。"
      });
      console.error("登録エラー:", error);
      alert("教職員情報の登録中にエラーが発生しました。");
    });
};

export const uploadFile = request => dispatch => {
  uploadFileApi(request)
    .then(data => {
      if (data.message !== null) {
        dispatch({ type: UPLOAD_FILE_FAIL, payload: `エラーコード: ${data.messageCode}\r\n${data.message}` });
        alert(`エラーコード: ${data.messageCode}\r\n${data.message}`);
      } else {
        dispatch({ type: UPDATE_SUCCESS, payload: "教職員情報の登録が完了しました。" });
        alert("教職員情報の登録が完了しました。");
      }
    })
    .catch(error => {
      dispatch({ type: UPLOAD_FILE_FAIL, payload: "ファイルのアップロード中にエラーが発生しました。" });
      console.error("ファイルのアップロードエラー:", error);
      alert("ファイルのアップロード中にエラーが発生しました。");
    });
};

export const update = request => dispatch => {
  updateApi(request).then(response => {
    if (response.message) {
      dispatch({ type: UPDATE_FAIL, payload: { message: response.message } });
      alert(response.message);
      return;
    }
    dispatch({ type: UPDATE_SUCCESS });
    alert("選択した教職員を更新しました。");
  });
};

export const search = request => dispatch => {
  searchApi(request).then(response => {
    const staffs = response.map((res, index) => {
      return {
        id: index,
        fmNumber: res.fmNumber,
        belongs: res.belongs,
        name: res.name,
        password: res.password,
        email: res.email,
        endDate: res.endDate
      };
    });
    dispatch({ type: SEARCH, payload: { staffs: staffs, params: request } });
  });
};

export const stop = request => dispatch => {
  stopApi(request).then(() => {
    alert("選択した教職員のアカウントを停止しました。");
    dispatch({ type: ACCOUNT_STOP, payload: { params: request } });
  });
};

export const excelDownload = () => dispatch => {
  sampleExcelDownloadApi().then(response => {
    dispatch({ type: EXCEL_DOWNLOAD, payload: { url: response.data } });

    // サーバーサイドのエンドポイントからデータのURLを取得
    const fileURL = response;

    // ダウンロード用リンクを作成
    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL; // データのURLを設定
    downloadLink.target = "_blank";
    downloadLink.download = "staff_upload_sample.xlsx"; // ダウンロード時のファイル名を指定

    // リンクをクリックしてダウンロードを開始します
    downloadLink.click();
  });
};
